import AnalyticsApi from 'utils/AnalyticsApi';
import { transformPlainParams } from 'utils/AnalyticsUtils';
import Helmet from 'react-helmet';

import { trackVar } from 'modules/Common/reducers/omniture';

export default class OmnitureAnalytics extends AnalyticsApi {
  constructor(options, store) {
    super("Omniture", "omniture", options);

    this.getState = store.getState;
    this.dispatch = store.dispatch;

    if (typeof window !== 'undefined' && window.s_gi) {
      const s = this.s = window.s_gi(options.suite);

      s.trackingServer = 'metrics.sky.com';
      s.trackingServerSecure = 'smetrics.sky.com';
      /* You may add or alter any code config here. */
      /* Link Tracking Config */
      s.trackDownloadLinks = false;
      s.trackExternalLinks = true;
      s.trackInlineStats = true;
      s.linkInternalFilters = `javascript:,${window.location.hostname}`;
      s.linkLeaveQueryString = false;
      s.linkTrackVars = "None";
      s.linkTrackEvents = "None";
      s.server = window.location.hostname;
    }
  }

  isSetUp() {
    return !!this.s;
  }

  pageView(...args) {
    const {
      title: pageTitle = ''
    } = Helmet.peek();

    this.s.pageName = pageTitle;

    const path = window.location.pathname.substr(1)
    const paths = path.split("/");
    const pathsLen = paths.length;

    this.s.prop25 = '';
    this.s.prop27 = '';
    this.s.prop31 = '';

    if (pathsLen > 0) {
      this.s.prop25 = paths[0];
      this.s.channel = paths[0] || 'home';
    }
    if (pathsLen > 1) {
      this.s.prop27 = `${paths[0]}/${paths[1]}`;
    }
    if (pathsLen > 2) {
      this.s.prop31 = path;
    }

    this.s.prop9 = window.location.href;

    super.pageView(...args);
  }

  permanentEvars() {
    const {
      common: {
        auth: {
          loggedIn = false
        } = {},
        omniture: {
          eVar57 = 'site'
        } = {},
        canary: {
          bucketId = ""
        } = {}
      } = {}
    } = this.getState();    

    return {
      eVar11: loggedIn ? 'logged-in' : 'not logged-in',
      eVar57,
      eVar37: bucketId
    }
  }

  permanentProps() {
    const {
      common: {
        omniture: {
          prop45 = '',
          prop47 = ''
        } = {}
      } = {}
    } = this.getState();

    return {
      prop45,
      prop47
    }
  }

  transformParams(params, map) {

    const {
      events = [],
      evars,
      props
    } = map;

    return {
      events: events,
      evars: evars ? transformPlainParams(params, evars) : {},
      props: props ? transformPlainParams(params, props) : {}
    }
  }

  sendTracking(name, { events = [], evars = {}, props = {} }, { isPage = false }) {

    this.checkForQueryStrings();

    evars = {...this.permanentEvars(), ...evars};
    props = {...this.permanentProps(), ...props};

    const trackVars = [
      ...Object.keys(evars),
      ...Object.keys(props),
      'events'
    ];

    this.setOmnitureVars(trackVars, events)

    if (isPage) {
      this.trackPage(evars, props, events);
    } else {
      this.trackLink(evars, props, name);
    }

    this.resetOmnitureVars();
  }

  trackPage(evars, props, events) {
    this.s.t({
      ...evars,
      ...props,
      events: events.join()
    });
  }

  trackLink(evars, props, name) {
    this.s.tl(
      true, // prevent Omniture click delay
      'o', // custom link
      name,
      {
        ...evars,
        ...props
      },
      false // disable forced link tracking
    );
  }

  getQueryStringValue(key = '') {
    const {
      common: {
        queryParams = {}
      } = {}
    } = this.getState();

    // Get a shallow copy whose keys are all lower case, so that case insensitive comparison can be made
    const lowerCaseQueryParams = Object.keys(queryParams).reduce((l, p) => Object.assign(l, {[p.toLowerCase()]: queryParams[p]}), {});

    // Destructure using lower case key, so that case insensitive comparison is made
    const {
      [key.toLowerCase()]: qsValue
    } = lowerCaseQueryParams;

    return qsValue;
  }

  dispatchQueryStringVar(qsKey = [], omnitureVar, acc = '-') {
    const qsVal = qsKey.map(o => this.getQueryStringValue(o)).filter(o => !!o).join(acc);
    if (qsVal) {
      this.dispatch(trackVar(omnitureVar, qsVal));
    }
  }

  checkForQueryStrings() {
    this.dispatchQueryStringVar(['DCMP'], 'prop45');
    this.dispatchQueryStringVar(['aff'], 'prop47');
    this.dispatchQueryStringVar(['app', 'version'], 'eVar57');
  }

  setOmnitureVars(vars, events) {
    this.s.linkTrackVars = vars.join();
    this.s.linkTrackEvents = events.join();
    this.s.events = events.join();
  }

  resetOmnitureVars() {
    this.s.linkTrackVars = "";
    this.s.linkTrackEvents = "";
    this.s.events = "";
  }
}



// WEBPACK FOOTER //
// ./utils/OmnitureAnalytics.js